import React from "react"
import PropTypes from "prop-types"


class BadgeExplainerModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      openExplainer: false
    }
  }

  render() {
    return(
        <div className="newPopUpWrapper" style={{position: 'absolute', padding: 12, zIndex: 8000}}>
          <button style={{float: 'right', marginTop: -5, marginRight: -10, cursor: 'pointer'}} onClick={() => this.props.closeModal()}>
            <img src={this.props.closeIcon} />
          </button>
          <div style={{marginTop: -100, marginLeft: 30}}>
            <img
              style={{maxWidth: 180, maxHeight: 180}}
              src={this.props.badge.image_url}
            />
          </div>
          <div style={{marginTop: 25}}>
            <h2 className="modalHeader">{this.props.badge.name}</h2>
            <h4 className="modalSubHeader" style={{paddingTop: 10}}>{this.props.badge.body}</h4>
          </div>
        </div>
    )
  }
}

export default BadgeExplainerModal;
